const Loader = () => (
    <div className="w-full h-full flex justify-center items-center py-2">
      <div className="bg-black/90 p-2 rounded-md">
        <span className="text-white animate-pulse">Loading...</span>
      </div>
    </div>
);

export default Loader;